import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, AlertProps, AlertTitle, Divider, styled } from '@mui/material';
import React, { FunctionComponent, ReactNode } from 'react';
import { ResponseStatus } from '@servicestack/client';


interface IBasicAlertProps {
    title?: string;
    description?: ReactNode;
    icon?: IconProp;
    severity?: AlertProps['severity'];
    responseStatus?: ResponseStatus;
}

const Title = styled(AlertTitle)(({theme }) => ({
    fontWeight: 'bold',
    paddingBottom: theme.spacing(2)
}));

const StyledDivider = styled(Divider)(({theme }) => ({
    margin: theme.spacing(2,0),
    opacity: 0.75
}));

const Pre = styled('pre')(({theme }) => ({
    margin: 0,
    padding: 0,
    width: '100%',
    overflow: 'auto'
}));

// const useAlertStyles = makeStyles()(() => ({
//     message: {
//         flex: '1 1 auto'
//     },
// }));

const BasicAlert: FunctionComponent<IBasicAlertProps> = ({
    title,
    description,
    icon,
    severity,
    responseStatus
}) => {
    if (!title && !description) {
        return null;
    }

    return (
        <Alert
            icon={icon ? <FontAwesomeIcon fixedWidth icon={icon} /> : undefined}
            severity={severity}
            sx={{overflow: 'auto'}}
        >
            {title && <Title>{title}</Title>}
            {description}
            {
                title && responseStatus?.message && (
                    <StyledDivider color={severity} />
                )
            }
            {
                responseStatus?.message && (
                    <Title>
                        {responseStatus?.message}
                    </Title>
                )
            }
            {
                responseStatus?.stackTrace && (
                    <Pre>
                        {responseStatus?.stackTrace}
                    </Pre>
                )
            }
        </Alert>
    )
};

export default BasicAlert;